import React, { FC, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { useElements, useStripe } from '@stripe/react-stripe-js'
import { Caution, MainHeadline } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { NavButton, OrangeButton } from 'components/Button'
import { CheckoutForm } from 'components/Checkout'
import { useDispatch, useSelector } from 'react-redux'
import { fetchShop, registerCard } from 'reducks/shop/operations'
import { getShopRef } from 'reducks/store/selectors'
import { State } from 'index'
import { getStripeError } from 'reducks/error/selectors'

const ContractCardTemplate: FC = () => {
  const dispatch = useDispatch()
  const shopRef = useSelector((state: State) => getShopRef(state))
  const stripeError = useSelector((state: State) => getStripeError(state))
  const stripe = useStripe()
  const elements = useElements()

  useEffect(() => {
    if (!shopRef) return
    dispatch(fetchShop(shopRef.id))
  }, [shopRef])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'クレジットカード情報'} />
      <Spacer size={20} />
      <CheckoutForm />
      <Spacer size={48} />
      {stripeError !== '' && (
        <>
          <Caution caution={stripeError} />
          <Spacer size={16} />
        </>
      )}
      <OrangeButton
        disabled={false}
        label={'保存する'}
        onClick={() => dispatch(registerCard(elements, stripe))}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default ContractCardTemplate
